/* eslint-disable no-else-return */
/* eslint-disable no-use-before-define */
import _ from 'underscore';

export function firstValue(...values) {
  return _.find(values, _.negate(_.isUndefined));
}

export function getInitializerValues(initializers) {
  const defaults = _.mapObject(initializers, i => getDefaultValue(i));
  const overrides = _.mapObject(initializers, i => getOverrideValue(i));

  return { defaults, overrides };
}

function getDefaultValue(initializer) {
  // unless specified otherwise, initializers work as "default" values
  if (!_.has(initializer, 'value')) {
    return initializer;
  } else if (_.result(initializer, 'type') !== 'override') {
    return initializer.value;
  } else {
    return undefined;
  }
}

function getOverrideValue(initializer) {
  if (_.result(initializer, 'type') === 'override') {
    return _.result(initializer, 'value');
  } else {
    return undefined;
  }
}
